// extracted by mini-css-extract-plugin
export default {"section":"Hero_section__e5M4G","content":"Hero_content__+tfv6","contactoBtn":"Hero_contactoBtn__2+26r"};